import { TFunction } from 'i18next';
import * as yup from 'yup';

import { REGEXES } from 'modules/authentication/presentation/constants';

export const UpdatePasswordSchema = (t: TFunction<'authentication'>) => {
  return yup.object().shape({
    password: yup
      .string()
      .matches(
        REGEXES.PASSWORD.FULL_PASSWORD,
        t('You must provide a password following all the requirements bellow'),
      )
      .required(t('You must provide a password')),
    confirmPassword: yup
      .string()
      .test('equal', t('The passwords are not the same'), function (value) {
        const ref = yup.ref('password');
        return value === this.resolve(ref);
      })
      .required(t('You must provide a password')),
  });
};
